import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { RAILWAY_PROJECT_ID_ANNOTATION } from '@internal/plugin-railway-common';
import { RailwayClient, railwayApiRef } from './api';

/**
 * Shown only where the entity names a Railway project. The permission is
 * checked inside the tab instead — this filter is a predicate over the entity
 * and cannot call a hook.
 */
const hasProjectId = {
  [`metadata.annotations.${RAILWAY_PROJECT_ID_ANNOTATION}`]: { $exists: true },
};

const railwayApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: railwayApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new RailwayClient(discoveryApi, fetchApi),
    }),
});

const railwayEntityContent = EntityContentBlueprint.make({
  params: {
    // Named for the provider, not the concept: the tab holds spend and services
    // as well as deployments, and `deployments` is a path other plugins are
    // likely to want on the same entity.
    path: 'railway',
    title: 'Railway',
    filter: hasProjectId,
    loader: async () => {
      const { EntityRailwayContent } = await import(
        './components/EntityRailwayContent'
      );
      return <EntityRailwayContent />;
    },
  },
});

// No overview card on purpose: everything it showed is one click away on the
// tab, and a project with several services had it reporting on none of them.
export const railwayPlugin = createFrontendPlugin({
  pluginId: 'railway',
  extensions: [railwayApi, railwayEntityContent],
});
